import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";

export function Skeleton({ className, as: Element = "div", ...props }: ComponentProps<"div"> & { as?: "div" | "span" }) {
  return <Element data-slot="skeleton" className={cn("motion-safe:animate-pulse rounded-md bg-muted-foreground/25 bg-linear-to-br from-background/40 via-border/50 to-muted-foreground/20 backdrop-blur-md inset-shadow-sm inset-shadow-background/70 ring-1 ring-inset ring-muted-foreground/15", className)} {...props} />;
}
